import { useState } from 'react';
import { EmptyState } from '@/components/shared/empty-state';
import { Combobox } from '@/components/shared/combobox';
import { useCourses, useCourseEnrollments } from '@/api/instructor-lessons';
import { EnrollmentLessons } from './_components/enrollment-lessons';

export function CompleteLessonsPage() {
  const [selectedCourseId, setSelectedCourseId] = useState<number>(0);
  const [selectedEnrollmentId, setSelectedEnrollmentId] = useState<number>(0);

  const { data: coursesRes, isLoading: loadingCourses, error: coursesError } = useCourses();
  const {
    data: enrollmentsRes,
    isLoading: loadingEnrollments,
    error: enrollmentsError,
  } = useCourseEnrollments(selectedCourseId);

  const courses = coursesRes?.data ?? [];
  const enrollments = enrollmentsRes?.data ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Completar Practicas</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Marca como completadas las lecciones presenciales de los empleados en tus cursos.
        </p>
      </div>

      {/* Selectors */}
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Curso</label>
          {loadingCourses ? (
            <div className="rounded-lg border border-border bg-muted/50 px-3 py-2 text-sm text-muted-foreground">
              Cargando cursos...
            </div>
          ) : coursesError ? (
            <div className="rounded-lg border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">
              Error cargando cursos
            </div>
          ) : (
            <Combobox
              value={selectedCourseId ? String(selectedCourseId) : ''}
              onChange={(v) => {
                setSelectedCourseId(v ? Number(v) : 0);
                setSelectedEnrollmentId(0);
              }}
              options={courses.map((c) => ({ value: String(c.id), label: c.title }))}
              placeholder="Seleccionar curso..."
              clearable
            />
          )}
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Empleado</label>
          {loadingEnrollments && selectedCourseId > 0 ? (
            <div className="rounded-lg border border-border bg-muted/50 px-3 py-2 text-sm text-muted-foreground">
              Cargando inscripciones...
            </div>
          ) : enrollmentsError && selectedCourseId > 0 ? (
            <div className="rounded-lg border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">
              Error cargando inscripciones
            </div>
          ) : (
            <Combobox
              value={selectedEnrollmentId ? String(selectedEnrollmentId) : ''}
              onChange={(v) => setSelectedEnrollmentId(v ? Number(v) : 0)}
              options={enrollments.map((e) => ({
                value: String(e.id),
                label: `${e.user.first_name} ${e.user.last_name}`,
                sublabel: `${e.progress}%`,
              }))}
              placeholder={
                !selectedCourseId
                  ? 'Selecciona un curso primero'
                  : enrollments.length === 0
                    ? 'Sin inscripciones activas'
                    : 'Seleccionar empleado...'
              }
              disabled={!selectedCourseId}
              clearable
            />
          )}
        </div>
      </div>

      {/* Enrollment progress */}
      {selectedEnrollmentId === 0 ? (
        <EmptyState
          title="Selecciona un empleado"
          description="Elige un curso y un empleado para ver y completar las lecciones presenciales."
        />
      ) : (
        <EnrollmentLessons enrollmentId={selectedEnrollmentId} />
      )}
    </div>
  );
}
